
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'

@Component
export default class Breadcrumb extends Vue {
  public separator: string = '/'
  public items : object[] = []

  @Watch('$route', { immediate: true, deep: true })
  public updateItems () {
    this.items = this.$route.path.split(this.separator).filter(_ => _).map(_ => this.getBreadcrumbOption(_))
  }

  private getBreadcrumbOption (name: string) {
    const route = this.$route.matched.find(_ => (_.name as string).toLowerCase() === name.toLowerCase())

    return {
      text: this.$t('Breadcrumb.' + name.toPascalCase()),
      disabled: route === undefined,
      exact: true,
      to: route ? route.path : ''
    }
  }
}
